import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Company from "../views/Company.vue";
import Product from "../views/Product.vue";
import Join from "../views/Join.vue";
import ContactUs from "../views/ContactUs.vue";
import News from "../views/News.vue";
import NewsDetail from "@/views/NewsDetail.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "首页",
    component: Home,
  },
  {
    path: "/company",
    name: "企业介绍",
    component: Company,
  },
  {
    path: "/product",
    name: "产品中心",
    component: Product,
  },
  {
    path: "/join",
    name: "招贤纳士",
    component: Join,
  },
  {
    path: "/news",
    name: "新闻动态",
    component: News,
  },
  {
    path: "/newsDetail",
    name: "新闻动态",
    component: NewsDetail,
  },
  {
    path: "/contact",
    name: "联系我们",
    component: ContactUs,
  },
  {
    path: "*",
    redirect: "/index",
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.name}-飞碟科技`;
  next();
});

export default router;
